import { useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { STATUS } from "../constants";
import * as routes from "../../../routes";
import { UserContext } from "../../../Context";

const BillCardView = ({ bills = [] }) => {
    const navigate = useNavigate();
    const { billReviewAccess } = useContext(UserContext);
    const location = useLocation();
    const filters = location.state?.filters || { status: "", date: null, user: "" };
    

    const getStatusBadgeClass = (status) => {
        switch (status?.toLowerCase()) {
            case STATUS.APPROVED:
                return "bg-green-100 text-green-700";
            case STATUS.REJECTED:
                return "bg-red-100 text-red-700";
            case STATUS.PENDING:
            default:
                return "bg-yellow-100 text-yellow-700";
        }
    };

    const formatDate = (dateStr) => {
        if (!dateStr) return "";
        const date = new Date(dateStr);
        return date.toLocaleDateString("en-IN", {
            day: "2-digit",
            month: "short",
            year: "numeric",
        });
    };

    return (
      <div className="block md:hidden space-y-4 p-4">
        {bills.map((bill) => (
          <div
            key={bill.id}
            onClick={() =>
              navigate(routes.VIEW_BILL.replace(":billId", bill.id), {
                state: { filters },
              })
            }
            className="flex justify-between items-start rounded-lg p-4 shadow-md border border-gray-300 bg-white hover:shadow-md transition-shadow"
          >
            {/* Left side */}
            <div className="flex flex-col items-start space-y-3">
              <span className="text-sm font-semibold text-gray-800 truncate max-w-[150px]">
                {bill.user_name || "User"}
              </span>
              <span className="text-sm font-semibold text-gray-800 truncate max-w-[150px]">
                {bill.site_name}
              </span>
              <span className="text-xs bg-blue-200 text-black px-2 py-0.5 rounded-full">
                {bill.category_name}
              </span>
            </div>

            {/* Right side */}
            <div className="flex flex-col gap-1 text-right truncate">
              <span className="text-sm text-gray-600 font-medium mb-1 truncate">
                {formatDate(bill.date)}
              </span>
              <span className="text-lg font-semibold text-gray-800 mb-1 truncate">
                ₹{bill.amount}
              </span>
              <span
                className={`text-xs font-medium px-2 py-1 rounded-full truncate ${getStatusBadgeClass(
                  bill.status
                )}`}
              >
                {bill.status
                  .toLowerCase()
                  .split("_")
                  .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                  .join(" ") || "N/A"}
              </span>
            </div>
          </div>
        ))}

        {bills.length === 0 && (
          <div className="text-center text-gray-500 text-sm">
            No bills found.
          </div>
        )}
      </div>
    );
};

export default BillCardView;